export default {
  methods: {
    _rte() {
      const c = this.$refs.replyBox;
      if (c && c.getEditor) return c.getEditor();
      return window.RichTextEditor && window.RichTextEditor.instances
        ? Object.values(window.RichTextEditor.instances)[0]
        : null;
    },
    toggleQuotePreview() {
      const rte = this._rte();
      if (!rte) return;

      const html = rte.getHTMLCode();

      const doc = new DOMParser().parseFromString(html, "text/html");

      let marker = doc.querySelector("style[data-rte-quote-preview]");

      if (marker) {
        marker.remove();
        this.isQuotePreviewCollapsed = false;
      } else {
        marker = doc.createElement("style");
        marker.setAttribute("data-rte-quote-preview", "true");
        marker.textContent = `
        .gmail_quote blockquote { display: none !important; }
        .gmail_quote hr{display:none !important;}
      `;

        doc.body.prepend(marker);
        this.isQuotePreviewCollapsed = true;
      }

      rte.setHTMLCode(doc.body.innerHTML);
    },

    normalizeQuotesBeforeSend() {
      const rte = this._rte();
      if (!rte) return;
      const html = rte.getHTMLCode();
      const doc = new DOMParser().parseFromString(html, "text/html");
      doc
        .querySelectorAll("style[data-rte-quote-preview]")
        .forEach((s) => s.remove());
      // rte.setHTMLCode(doc.body.innerHTML);
      return doc.body.innerHTML;
    },
    checkQuoteNoted(note) {
      if (!note) return "";

      const parser = new DOMParser();
      const doc = parser.parseFromString(note, "text/html");

      const gmailQuote = doc.querySelector(".gmail_quote");

      if (gmailQuote) {
        return true;
      } else {
        return false;
      }
    },
    openFirstGmailQuote(rowIndex) {
      const noteEls = this.$el.querySelectorAll(".note");
      const note = noteEls[rowIndex];
      console.log(note, noteEls);
      if (!note) return;

      const firstQuote = note.querySelector(".gmail_quote");
      const refNoteQuote = note.querySelector(".ref_note");
      console.log(refNoteQuote);
      if (!firstQuote && !refNoteQuote) return;
      if (refNoteQuote) refNoteQuote.classList.toggle("is-open");
      if (firstQuote) firstQuote.classList.toggle("is-open");
    },
  },
};
